<template>
  <div class="entered auto1200">
    <h3 class="text-basic">{{ shopText }}</h3>
    <p>
      请直接登录商家平台，系统将在&nbsp;
      <i class="text-error">{{ time }}</i>
      &nbsp;秒内自动为您跳转到入驻管理页面，
    </p>
    <a class="el-button" :href="shopUrl" target="_blank">快速跳转</a>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      time: 5,
      timer: null
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.isAdmin,
      isStaioned: state => state.isStaioned,
      applyStatus: state => state.applyStatus
    }),
    shopUrl() {
      const href = location.href
      let jumpStr = ''
      // 注册账户，已经申请过，但未通过，跳转到信息页面
      if (!this.isStaioned && this.applyStatus) {
        jumpStr = 'merchant/contact/detail'
      }
      if (href.indexOf('st') !== -1 || href.indexOf('dev') !== -1) {
        return 'http://shop.st.xiaomiyoupin.com/' + jumpStr
      } else {
        return 'https://shop.xiaomiyoupin.com/' + jumpStr
      }
    },
    shopText() {
      if (!this.isStaioned && this.applyStatus) {
        return '您已经提交过入驻信息'
      }
      return '您已经是有品商家'
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.countDown()
  },
  methods: {
    countDown() {
      const href = location.href
      this.timer = setInterval(() => {
        --this.time
        if (this.time <= 0) {
          clearInterval(this.timer)
          // 这里跳转新路由
          if (href.indexOf('st') !== -1 || href.indexOf('dev') !== -1) {
            location.href = 'http://shop.st.xiaomiyoupin.com/'
          } else {
            location.href = 'https://shop.xiaomiyoupin.com/'
          }
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less">
.entered {
  font-size: 12px;
  height: 78vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    font-size: 16px;
  }
  p {
    margin: 20px 0;
    color: #666;
  }

  a {
    width: 88px;
    height: 25px;
    font-size: 12px;
    line-height: 25px;
    border-color: #409eff;
    color: #409eff;
    border-radius: 0;
    padding: 0;
  }
}
</style>
